import React from 'react';
import './Item.scss';
// import {ReactComponent as ItemVector} from './item.svg';
// import {ReactComponent as OrnamentVector} from './ornament.svg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class Item extends React.Component {
  constructor(props) {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = async (event) => {
    event.preventDefault();
    this.props.onSelect(this.props.item);
  }
  
  render() {
    var status = this.props.item.get("Status");
    if (this.props.item["selected"]) {
      status = "Selected";
    }
    return (
      <div className={"item item-"+this.props.index+" item-status-"+status+" item-type-"+this.props.item.get("Type")} onClick={this.handleClick}>
        {/* <ItemVector status={this.props.status}/> */}
        {/* <OrnamentVector status={this.props.status}/> */}
        <div className="inner"></div>
        {/* Your <FontAwesomeIcon icon="coffee" /> is hot and ready! */}
      </div>
    );
  }
}

export default Item;
